import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import MaskedInput from 'react-text-mask';

import { commonStyles } from '../../styles/styles';

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        '(',
        /[0-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
      ]}
      id="formatted-text-mask-input"
    />
  );
}

const PhoneField = ({ classes, meta, registrationForm, input }) => {
  const conditionError = meta.error && meta.touched;
  return (
    <FormControl
      className={`${classes.formField} ${registrationForm ? classes.regField : false}`}
      aria-describedby="name-error-text"
      error={conditionError}
    >
      <Typography className={classes.formInputLabel} htmlFor="phone-number">
        Phone number
      </Typography>
      <Input
        {...input}
        aria-describedby="name-error-text"
        error={conditionError}
        id="phone-number"
        inputComponent={TextMaskCustom}
        type="Text"
        className={`${classes.formInput} ${conditionError ? classes.inputError : false}`}
        disableUnderline
        classes={{ focused: classes.formInputFocus }}
      />
      {conditionError && (
        <FormHelperText id="name-error-password" className={classes.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

PhoneField.propTypes = {
  classes: PropTypes.instanceOf(Object),
  meta: PropTypes.instanceOf(Object),
  registrationForm: PropTypes.bool,
  input: PropTypes.instanceOf(Object),
};

const styles = () => ({
  ...commonStyles,
});

export default compose(
  withState('showPassword', 'handleShowPassword', false),
  withStyles(styles),
)(PhoneField);



// WEBPACK FOOTER //
// ./src/Components/Form/PhoneField.jsx